import type { NewsItem } from '../content/siteContent';

export function getNewsTimestamp(item: NewsItem) {
  const parsed = Date.parse(`${item.date || ''}T12:00:00`);
  return Number.isNaN(parsed) ? 0 : parsed;
}

function getPublishedAtTimestamp(item: NewsItem) {
  const raw = item.publishedAt || item.date || '';
  const parsed = Date.parse(`${raw}T12:00:00`);
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function getPublishedNews(items: NewsItem[]) {
  return items
    .filter((item) => item.enabled && item.title.trim() && item.excerpt.trim())
    .slice()
    .sort((a, b) => getPublishedAtTimestamp(b) - getPublishedAtTimestamp(a));
}

export function formatNewsBadge(date: string) {
  const parsed = Date.parse(`${date || ''}T12:00:00`);

  if (Number.isNaN(parsed)) {
    return {
      day: 'GO',
      month: 'ACTU',
    };
  }

  const formatter = new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: 'short',
  });
  const [day = 'GO', month = 'ACTU'] = formatter.format(new Date(parsed)).replace('.', '').split(' ');

  return {
    day,
    month: month.toUpperCase(),
  };
}

export function formatNewsDate(date: string) {
  const parsed = Date.parse(`${date || ''}T12:00:00`);

  if (Number.isNaN(parsed)) {
    return 'Actualité Gameside';
  }

  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(new Date(parsed));
}
